module.exports = __webpack_public_path__ + "static/media/ePosterMobile.ece0f86c.jpg";